<template>
  <div class="redirect-wrapper">
    <v-icon size="42">mdi-check-circle</v-icon>
    <div class="redirect-header">{{ headerText }}</div>
    <div class="redirect-desc">{{ $t("redirect.auto_redirect") }}</div>
    <div class="redirect-loader"></div>
  </div>
</template>

<script>
  export default {
    name: "Redirect",
    data() {
      return {
        type: this.$route.query.type,
        headerText: "",
      };
    },

    mounted() {
      this.$store.commit("SET_SKIP_LOGOUT_REDIRECT", false);
      if (!this.type) {
        this.$router.replace({ name: "login" });

        return;
      }

      if (this.type === "organization") {
        this.headerText = this.$t("redirect.organization_deleted");
        this.redirect();
      } else {
        this.$router.replace({ name: "login" });

        return;
      }
    },
    methods: {
      redirect() {
        setTimeout(() => {
          // Additional check to prevent error if user clicks back on redirect
          if (this.$route.name !== "login") {
            this.$router.replace({ name: "login" });
          }
        }, 3000);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/functions.scss";
  @import "@core/preset/preset/typography/index.scss";

  .redirect-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
    flex-direction: column;
    gap: 13px;

    i {
      //non-variable color provided in design
      color: #a5a5a5;
    }

    .redirect-header {
      @include heading-4();
      color: get-color("headline");
      font-weight: 600 !important;
      font-family: Inter;
    }

    .redirect-desc {
      @include text-body-2();
      color: get-color("headline");
    }

    .redirect-loader {
      position: relative !important;
      width: 16px !important;
      height: 16px !important;
      border-radius: 20px;
      background-color: #a5a5a5;
      color: #a5a5a5;
      animation: dot-flashing 0.5s linear alternate;
      animation-delay: 0.25s;
      animation-iteration-count: infinite;

      &::before,
      &::after {
        content: "";
        display: inline-block;
        position: absolute;
        top: 0;
      }

      &::before {
        left: -25px;
        width: 16px;
        height: 16px;
        border-radius: 20px;
        background-color: #a5a5a5;
        color: #a5a5a5;
        animation: dot-flashing 0.5s infinite alternate;
        animation-delay: 0s;
      }

      &::after {
        left: 25px;
        width: 16px;
        height: 16px;
        border-radius: 20px;
        background-color: #a5a5a5;
        color: #a5a5a5;
        animation: dot-flashing 0.5s infinite alternate;
        animation-delay: 0.5s;
      }

      @keyframes dot-flashing {
        0% {
          background-color: #a5a5a5;
        }
        50%,
        100% {
          background-color: #eaeaea;
        }
      }
    }
  }
</style>
